import React from 'react';
import './DestinationsVideo.css';

const DestinationsVideo: React.FC = () => {
  return (
    <div className="sticky-background-container" data-name="Header Video" id="node-403_5102">
      <video 
        className="sticky-background-video" 
        data-name="Video"
        id="node-439_15966"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/assets/Destinations page hero video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="video-overlay" />
    </div>
  );
};

export default DestinationsVideo;